export class PepParticipacion {

    model = {
        id: { value: null, export: false },
        idp: { value: null, export: false },
        razon_social: {
            value: '',
            export: false,
            header: 'Nombre / Razón Social',
            required: 'Información requerida',
            maxLength: 'Máximo 350 caracteres',
            minLength: 'Mínimo 3 caracteres',
            max: 350,
            min: 3,
            table: true,
            filter: false,
            sort: true
        },
        nacionalidad: {
            value: null,
            export: false,
            header: 'Nacionalidad',
            table: true,
            required: ' Buscar por nacionalidad'
        },
        porcentaje: {
            value: 0,
            export: true,
            table: true,
            header: '% Participación (mayor o igual a 10%)',
            required: 'Valor requerido',
            min: 10,
            minLength: 'Valor mínimo requerido es 10',
            max: 100,
            maxLength: 'Valor máximo requerido es 100'
        },        
    }
    optionLabel = 'nombre'
}
